// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/wp-" + chunkId + "." + {"448":"dbc4e6091db4838b9c48","983":"bf25dd37deda6337bd54"}[chunkId] + ".js";
};